// The search-only key comes from the page (AccuVars 'search'), not the build, so no key is
// compiled into the bundles. algoliaAppSecret is only on pages Cloudflare cached before the
// switch, so search keeps working on them until the purge: drop it once the old key is revoked.
const algoliaSearchKey = () => window.accuvars?.search?.algoliaSearchKey
    ?? window.accuvars?.search?.algoliaAppSecret
    ?? ''

export default algoliaSearchKey
